import type { NotificationRead } from '@galigeo-store/galigeojs';
import { NotificationPopup } from '@galigeo-store/ui-components';
import { websocketService } from './websocket.service';
import { publish, PUBSUB_TOPICS } from '../state/pubsub';
import { PortalAppContext } from '../state/portal-appcontext';

const handleNotificationClick = (event: any) => {
  console.log('Notification clicked:', event);
};

const handleNotificationLinkClick = (event: any) => {
  const { link } = event.detail;
  if (link?.type === 'map' && link?.docId) {
    const map = PortalAppContext.getMaps().find((m: any) => m.id === link.docId);
    if (map) {
      publish(PUBSUB_TOPICS.SHOW_CONTENT, { map: { ...map, categoryId: map.categoryId ?? 'others' } });
    } else {
      console.warn(`[notification] Map with docId "${link.docId}" not found`);
    }
  }
};

const onNotification = (notification: NotificationRead) => {
  // Play a sound when a notification is received
  const audio = new Audio(`${import.meta.env.BASE_URL}notification.wav`);
  audio.play();
  // Create and display the notification popup
  const app = document.querySelector<HTMLDivElement>('#app')!;
  const notificationElement = new NotificationPopup();
  notificationElement.notification = notification;
  notificationElement.addEventListener('notification-popup-click', handleNotificationClick);
  notificationElement.addEventListener('notification-link-click', handleNotificationLinkClick);
  app.appendChild(notificationElement);
};

export function initNotificationDisplay() {
  websocketService.subscribeToNotifications(
    onNotification,
    () => {},
    (event) => {
      console.warn('[portal] WebSocket notification connection failed — real-time notifications unavailable.', event);
    },
  );
}
